import { DockviewDefaultTab, type IDockviewPanelHeaderProps } from "dockview"
import type { JSX, MouseEvent } from "react"

export default function CustomTabComponent(props: IDockviewPanelHeaderProps): JSX.Element {
  const onContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault()
  }

  return (
    <DockviewDefaultTab
      onContextMenu={onContextMenu}
      {...props}
      hideClose={true}
    />
  )
}
